import Loading from "./loading";

export default function InitialLoading(props) {
  return (
    <>
      <div className={"container-fluid vh-100 d-flex align-items-center"}>
        <div className={"col text-center align-items-center align-content-center"}>
          <Loading />
        </div>
      </div>
    </>
  );
}
